import { getCategory } from '../../services/category'
import * as types from '../types'

export const fetchCategories = async (dispatch) => {
  const categories = await getCategory()
  dispatch({ type: types.FETCH_CATEGORIES, payload: categories })
}
